<template>
  <span class="vehicle-inspection-icons" v-if="this.vehicle" :data-tooltip="warning">
    <i v-if="stage === 1" class="fa fa-exclamation-triangle"></i>
    <i v-if="stage === 2" class="fa fa-gears"></i>
    <i v-if="stage === 3" class="fa fa-paint-brush"></i>
    <i v-if="stage === 4" class="fa fa-camera"></i>
  </span>
</template>

<style scoped lang="less">
.vehicle-inspection-icons {
  color: #ff4136;
  display: none;
}
</style>

<script>
export default {
  data () {
    return {}
  },
  props: {
    vehicle: null
  },
  computed: {
    warning () {
      if (this.stage === 0) return
      return ([
        'This vehicle has not been inspected yet.',
        'This vehicle has been inspected but has not been through mechanical, detailing or the imaging studio yet.',
        'This vehicle has been inspected and through mechanical but has not been through detailing or the imaging studio yet.',
        'This vehicle has been inspected and through mechanical and detailing but not the imaging studio.',
        'This vehicle is ready for sale.'
      ])[this.stage - 1]
    },
    stage () {
      if (!this.vehicle) return 0
      // Handle case of new cars which don't have these fields.
      if (!('recon_time' in this.vehicle)) return 5
      if (this.vehicle.studio_time) return 5
      if (this.vehicle.cosm_time) return 4
      if (this.vehicle.mech_time) return 3
      if (this.vehicle.inspect_time || this.vehicle.recon_time) return 2
      return 1
    }
  }
}
</script>